var _TextTag;
import cn from "classnames";
import { useMediaQuery } from "@crehana/react-hooks";
import { Container, LazyImage, TextTag } from "@crehana/ui";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var InductionBanner = function InductionBanner() {
  var _useMediaQuery = useMediaQuery('lg'),
    isLg = _useMediaQuery.matches;
  var _useMediaQuery2 = useMediaQuery('sm'),
    isSm = _useMediaQuery2.matches;
  var _useMediaQuery3 = useMediaQuery('md'),
    isMd = _useMediaQuery3.matches;
  var _useMediaQuery4 = useMediaQuery('320px'),
    isXs = _useMediaQuery4.matches;
  var INDUCTION_BANNER_IMAGE_URL = 'https://crehana-public-catalog.imgix.net/images/app/gallery/2021/09/09/0cc5b518/6c4abd60.png';
  var getBannerHeight = function getBannerHeight() {
    if (isLg) return '292px';
    if (isSm || isMd) return '224px';
    if (isXs) return '344px';
  };
  return /*#__PURE__*/_jsx(Container, {
    children: /*#__PURE__*/_jsxs("section", {
      className: cn('rounded-5 flex flex-col sm:flex-row'),
      style: {
        height: getBannerHeight(),
        background: 'linear-gradient(272.32deg, #9C86F9 2.66%, #6F4EF6 52.04%, #3418A8 97.48%)'
      },
      children: [/*#__PURE__*/_jsxs("div", {
        className: cn('pl-12 sm:pl-48 w-full sm:w-1/2', isLg && 'pt-64', isMd && 'pt-32', isSm && 'pt-36', isXs && 'pt-20'),
        style: {
          height: isXs && !isSm ? '229px' : '100%'
        },
        children: [_TextTag || (_TextTag = /*#__PURE__*/_jsx(TextTag, {
          className: "mb-12",
          label: "Rutas de aprendizaje",
          type: "green"
        })), /*#__PURE__*/_jsx("p", {
          className: cn('text-white font-h2', isSm && 'font-h4'),
          children: "Culmina a tiempo tu inducci\xF3n y podr\xE1n asignarte cursos para potenciar tu aprendizaje"
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: cn('h-full w-full sm:w-1/2'),
        style: {
          height: isXs && !isSm ? '115px' : '100%'
        },
        children: /*#__PURE__*/_jsx(LazyImage, {
          className: "w-full h-full",
          imgClassName: "object-cover rounded-5",
          alt: "Banner de Inducci\xF3n",
          src: INDUCTION_BANNER_IMAGE_URL
        })
      })]
    })
  });
};
export default InductionBanner;